import React from "react";
import { Button } from "reactstrap";
import { useNavigate } from "react-router";

const EligibilityFaculty = () => {
  const navigate = useNavigate();

  return (
    <section className="py-4">
      <div className="container">
        <div className="mx-lg-3 position-relative border-radius-xl overflow-hidden">
          <div className="py-3 z-index-2 position-relative">
            <div className="row">
              <div className="mx-auto text-left">
                <h3 className="mb-2">Teaching Mode</h3>
                <p className="mb-3">
                  The workshop will include practical exercises, group work, and
                  discussion around common SM&E issues. Resources for further
                  study and research will be provided. Participants are expected
                  to attend all sessions during the first week and have options
                  during the third week. Participants who have previously
                  completed a monitoring and evaluation (M&E) course can opt for
                  GIS and one of the tracks available during the third week.
                  This workshop will be offered in English.
                </p>
              </div>
            </div>
          </div>
          <div className="py-3 z-index-2 position-relative">
            <div className="row">
              <div className="mx-auto text-left">
                <h3 className="mb-2">Eligibility</h3>
                <p className="mb-3">
                  This workshop targets individuals with 0–5 years of experience
                  working in SM&E who currently work as National Malaria Control
                  Program staff at either the national or subnational level; NGO
                  and donor personnel responsible for oversight of malaria
                  programs, especially in SM&E; and other individuals with a
                  professional interest in SM&E of malaria control programs.
                  Applicants should be proficient in English, have some
                  analytical skills, and have current responsibilities for
                  developing and implementing SM&E plans. Computer literacy and
                  experience with data systems is desired. Individuals
                  interested in attending GIS and one of the two tracks only
                  must have previously attended a MEASURE Evaluation M&E of
                  Malaria Programs workshop or any M&E course (proof required).
                </p>
              </div>
            </div>
          </div>
          <div className="py-3 z-index-2 position-relative">
            <div className="row">
              <div className="mx-auto text-left">
                <h3 className="mb-2">Facilitators</h3>
                <p className="mb-3">
                  The course will be taught by facilitators from the School
                  of Public Health, University of Ghana and experts from the Ghana National Malaria Control Program,
                  World Health Organization (WHO), and PMI Measure Malaria.
                </p>
              </div>
            </div>
          </div>
          <div className="py-3 z-index-2 position-relative">
            <div className="row">
              <div className="mx-auto text-left">
                <h3 className="mb-2">Application Procedures and Deadline </h3>
                <p className="mb-3">
                  Individuals who want to take part in the workshop should
                  submit their application and reference form through the
                  following link as soon as July 31, 2024.
                </p>
                <Button
                  className="btn-round btn-warning"
                  size="lg"
                  onClick={() => navigate("/sign-up")}
                >
                  Click Here To Apply
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EligibilityFaculty;
